import type { ReactNode } from 'react';

/**
 * Cabecera de pantalla con el marcado de la Power App (`src/components/page-header.tsx`): título,
 * descripción y, opcionalmente, una acción a la derecha. El título admite marcado (p. ej., el número y la
 * insignia de estado del detalle, que así forman parte del encabezado).
 */
export function PageHeader({ title, description, action }: { title: ReactNode; description: string; action?: ReactNode }) {
  return (
    <header className="flex flex-col gap-4 border-b border-border pb-5 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
      <div className="max-w-3xl space-y-1.5">
        <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">{title}</h1>
        <p className="text-sm leading-6 text-muted-foreground">{description}</p>
      </div>
      {action ? <div className="flex shrink-0 flex-wrap items-center gap-2">{action}</div> : null}
    </header>
  );
}
